export const module = {
  info: {
    name: 'voip-testing-panel-default-setting',
    caption: 'voip testing panel default setting'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
